module.exports = __webpack_public_path__ + "static/media/bettair_color@2x.c7a9e25e.png";